import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

const COVER_VARIANTS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'neutral'];

/**
 * Pick a deterministic cover variant from a string seed so the same event
 * always gets the same cover (without needing a backend field).
 */
export function pickCoverVariant(seed) {
    const value = typeof seed === 'string' ? seed : String(seed ?? '');
    if (!value) {
        return COVER_VARIANTS[0];
    }

    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash |= 0;
    }
    const paletteOrder = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
    const index = Math.abs(hash) % paletteOrder.length;
    return paletteOrder[index];
}

export default function CoverArt({
    variant = 'a',
    glyph,
    className = '',
    children,
    ...rest
}) {
    const variantClass = COVER_VARIANTS.includes(variant)
        ? `cover-art--${variant}`
        : 'cover-art--a';

    return (
        <div className={classNames('cover-art', variantClass, className)} {...rest}>
            {glyph ? <span className="cover-art__glyph" aria-hidden="true">{glyph}</span> : null}
            {children}
        </div>
    );
}

CoverArt.propTypes = {
    variant: PropTypes.oneOf(COVER_VARIANTS),
    glyph: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node,
};
